var _path, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPrintWarning = function SvgPrintWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Print Internal Cost",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 40
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon awesome-print",
    d: "M24.5 10.5V4.225a1.751 1.751 0 0 0-.512-1.238L21.512.512A1.75 1.75 0 0 0 20.275 0H5.25A1.75 1.75 0 0 0 3.5 1.75v8.75A3.5 3.5 0 0 0 0 14v6.125A.875.875 0 0 0 .875 21H3.5v5.25A1.75 1.75 0 0 0 5.25 28h17.5a1.75 1.75 0 0 0 1.75-1.75V21h2.625a.875.875 0 0 0 .875-.875V14a3.5 3.5 0 0 0-3.5-3.5Zm-3.5 14H7v-5.25h14Zm0-12.25H7V3.5h10.5v2.625a.875.875 0 0 0 .875.875H21Zm2.625 3.938a1.313 1.313 0 1 1 1.313-1.312 1.313 1.313 0 0 1-1.313 1.312Z",
    fill: "#002069"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 536",
    transform: "translate(14 22)",
    fill: "#309dd9",
    stroke: "#309dd9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 17,
    rx: 2.5,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon ionic-md-information",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 280",
    d: "M21.313 29.013h3.721v9.633h-3.721Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 281",
    d: "M21.313 23.688h3.721v3.375h-3.721Z"
  }))));
};
export default SvgPrintWarning;